import AppSidebar from './AppSidebar';


const AppMain = (props: any) => (
    <div id="app-main">
        {props.children}
    </div>
)


const AppWrapper = (props: any) => {
    return (
        <div id="app-wrapper" className='flex'>
            <AppSidebar />
            <AppMain {...props} />
        </div>
    );
};

export default AppWrapper;